import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { graphql, gql, compose } from 'react-apollo';

import { Step, Stepper, StepLabel } from 'material-ui/Stepper';
import { Tabs, Tab } from 'material-ui/Tabs';

import TownForm from '../TownForm';
import UploadTownPapers from '../UploadTownPapers/UploadTownPapers';

import config from '../../config';

const createTownMutation = gql`
    mutation CreateTownMutation($tournamentId: ID!, $town: TownInput) {
        createTown(tournamentId: $tournamentId, town: $town) {
            _id
            tournament {
                _id
                number
                gradeSettings {
                    number
                    level
                }
            }
            name {
                ru
                local
            }
            gradeSettings {
                number
                level
            }
        }
    }
`;

class CreateTown extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        createTown: PropTypes.func.isRequired,
    };

    state = {
        stepIndex: 0,
        townDataSource: [],
        season: 'fall',
    };

    componentDidMount() {
        fetch(`${config.backend}/tournaments/${this.props.tournament._id}/towns/add-suggestions`, {
            method: 'GET',
            credentials: 'include',
        })
            .then(res => res.json())
            .then(towns => this.setState({ townDataSource: towns.map(town => ({ text: town.name.ru, value: town })) }));
    }

    handleCreateTown = town => {
        this.props
            .createTown({
                variables: {
                    town,
                    tournamentId: this.props.tournament._id,
                },
            })
            .then(({ data: { createTown: town } }) => {
                this.setState({
                    town,
                    stepIndex: 1,
                });
            });
    };

    handlePapersUploaded = () => {
        this.setState({
            stepIndex: 2,
        });
    };

    handleParticipantsRegistered = () => {
        this.setState({
            stepIndex: 3,
        });
    };

    render() {
        const {
            intl: { formatMessage },
            tournament,
        } = this.props;
        const { stepIndex, town, townDataSource, season } = this.state;

        return (
            <div>
                {stepIndex === 0 && (
                    <h2>
                        <FormattedMessage id="AdminHomePage.New Town" />
                    </h2>
                )}
                <Stepper activeStep={stepIndex}>
                    <Step>
                        <StepLabel>
                            <FormattedMessage id="CreateTown.Register Town" />
                        </StepLabel>
                    </Step>
                    <Step>
                        <StepLabel>
                            <FormattedMessage id="CreateTown.Upload papers" />
                        </StepLabel>
                    </Step>
                    <Step>
                        <StepLabel>
                            <FormattedMessage id="CreateTown.Register Participants" />
                        </StepLabel>
                    </Step>
                </Stepper>
                {stepIndex === 0 && (
                    <TownForm regList={{}} onCreateTown={this.handleCreateTown} townDataSource={townDataSource} />
                )}
                {(stepIndex === 1 || stepIndex === 2) && (
                    <Fragment>
                        <Tabs
                            value={season}
                            onChange={season => this.setState({ season })}
                            tabItemContainerStyle={{ background: 'transparent' }}
                        >
                            <Tab
                                label={formatMessage({ id: 'OrgHomePage.fall' })}
                                style={{ color: 'rbga(0, 0, 0, 0.87)' }}
                                value="fall"
                            />
                            {Boolean(tournament.t && tournament.v) && (
                                <Tab
                                    label={formatMessage({ id: 'OrgHomePage.spring' })}
                                    style={{ color: 'rbga(0, 0, 0, 0.87)' }}
                                    value="spring"
                                />
                            )}
                        </Tabs>
                        <br />
                        <UploadTownPapers
                            town={this.state.town}
                            onParticipantsRegistered={this.handleParticipantsRegistered}
                            onPapersUploaded={this.handlePapersUploaded}
                            season={season}
                        />
                    </Fragment>
                )}
                {stepIndex === 3 && (
                    <div>
                        <h2>
                            <FormattedMessage id="RegisterTown.success" />
                        </h2>
                        <Link to={`/tournaments/${town.tournament.number}/towns/${town._id}/${season}`}>
                            <FormattedMessage id="RegListsList.town" />
                        </Link>
                    </div>
                )}
            </div>
        );
    }
}

export default compose(
    graphql(createTownMutation, { name: 'createTown' }),
    injectIntl
)(CreateTown);



// WEBPACK FOOTER //
// ./src/Components/CreateTown/CreateTown.js